import { JobRanking } from '@doda/common/src/types/jobSearchList/jobContent';
import { Box, TabsWithPanel } from '@doda/io-react/common';
import { RankingPanel } from './RankingPanel';
import styles from './index.module.scss';

/**
 * RankingContainerのprops
 * @property jobRankings 1ページで表示する複数軸の求人ランキング
 */
interface RankingContainerProps {
  jobRankings: JobRanking[];
}

/**
 * ランキングコンテナ
 * 求人ランキングの白枠部分を出力するコンポーネント
 * 複数軸の求人ランキングの場合はタブを含めて出力する
 */
export const RankingContainer = ({ jobRankings }: RankingContainerProps) => {
  if (jobRankings.length === 0) {
    return null;
  }

  // IOコンポーネントに渡すため、ランキングの軸数をstringに変換する
  const getPanelCount = (): '2' | '3' | undefined => {
    if (jobRankings.length === 2) return '2';
    if (jobRankings.length === 3) return '3';
    return undefined;
  };

  const panelCount = getPanelCount();

  return (
    <>
      {panelCount ? (
        <TabsWithPanel
          panels={jobRankings.map((ranking) => (
            <RankingPanel
              key={ranking.searchAxis.queryKey}
              jobRanking={ranking}
            />
          ))}
          tabTexts={jobRankings.map((ranking) => ranking.searchAxis.label)}
          panelCount={panelCount}
          tabDesign="tabInner"
          shadow="blue"
          className={styles.rankingContainer__tabPanel}
        />
      ) : (
        <Box
          radius="4"
          boxShadow="blue"
          border="gray"
          className={styles.rankingContainer__singlePanelWrapper}
        >
          <RankingPanel jobRanking={jobRankings[0]} />
        </Box>
      )}
    </>
  );
};
